export default __webpack_public_path__ + "static/media/ISSO CLASS-3 EXAM PATTERN 2026-27.aed71900.pdf";